import type { TypographyProps } from "@mui/material"
import { Typography } from "@mui/material"
import type { FC, ReactNode } from "react"

interface Props extends TypographyProps {
	text?: ReactNode
}
export const Text: FC<Props> = ({ text, ...props }) => {
	if (typeof text === "string") {
		return <Typography {...props}>{text}</Typography>
	}

	return text ?? null
}
